import React, { useState, useEffect, useRef } from 'react';
import { connect } from 'react-redux';
import Paper from '@material-ui/core/Paper';
import { makeStyles } from '@material-ui/core/styles';
import { checkPlaceMergeStats } from 'reducers/PlacesReducer';
import { handleError } from 'reducers/ErrorReducer';
import Checkbox2 from 'components/Checkbox2';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import { genColHeaderName } from 'utils/functions';
import { showSpinner, hideSpinner } from 'reducers/UiReducer';

const useStyles = makeStyles((theme) => ({
  error: {
    marginBottom: 16,
  },
  stats: {
    '& td': {
      fontSize: 16,
      paddingRight: 16,
    },
  },
  addressDetails: {
    display: 'inline-block',
    padding: '8px 16px',
    fontSize: 18,
    marginBottom: 16,
    '& span': {
      display: 'inline-block',
      color: theme.palette.secondary.main,
      marginRight: 8,
    },
    '& b': {
      fontWeight: 'bold',
    },
  },
}));

function Review(props) {
  const {
    source,
    target,
    data,
    setLoading,
    placeData,
    setPlaceData,
    deleteSource,
    setDeleteSource,
  } = props;
  const [stats, setStats] = useState(null);
  const mountedRef = useRef(true);
  const classes = useStyles();

  useEffect(() => {
    processTargetData();
    checkStats();
    return () => {
      mountedRef.current = false;
    };
    // eslint-disable-next-line
  }, []);

  const processTargetData = () => {
    const newData = { ...target };
    data.forEach((i) => {
      const key = i.field;
      const val = i.isTargetVal ? i.targetVal : i.sourceVal;
      newData[key] = val;
    });
    setPlaceData(newData);
  };

  const checkStats = async () => {
    setLoading(true);
    props.showSpinner();
    try {
      const result = await checkPlaceMergeStats(source.ptsPlaceID);
      if (!result || !mountedRef.current) return;
      const stats = [];
      Object.entries(result).forEach(([key, val]) => {
        stats.push({ key, val });
      });
      setStats(stats);
    } catch (err) {
      props.handleError(err);
    }
    setLoading(false);
    props.hideSpinner();
  };

  const renderPlace = () => {
    if (!placeData) return '';
    const { PlaceID, PlaceName } = placeData;
    return (
      <Paper variant="outlined" className={classes.addressDetails}>
        <span>{PlaceID}</span> <b>{PlaceName}</b>
      </Paper>
    );
  };

  const renderDataUpdates = () => {
    if (!stats) return '';
    return (
      <div className={classes.stats}>
        <h5>Records to be updated:</h5>
        <table>
          <tbody>
            {stats.map((row) => (
              <tr key={row.key}>
                <td>{genColHeaderName(row.key)}:</td>
                <td>{row.val}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    );
  };

  const renderDeleteSource = () => {
    return (
      <div>
        <FormControlLabel
          control={
            <Checkbox2 checked={deleteSource} onChange={(ev, val) => setDeleteSource(val)} />
          }
          label={`Delete Place - ${source.PlaceName} ${source.PlaceID}`}
        />
      </div>
    );
  };

  return (
    <div>
      {renderPlace()}
      {renderDeleteSource()}
      {renderDataUpdates()}
    </div>
  );
}

const mapStateToProps = (state) => ({
  dictionary: state.dictionary,
});

export default connect(mapStateToProps, { handleError, showSpinner, hideSpinner })(Review);
